import React, { FC } from 'react';
import { PageHeading, useMe } from 'src/common';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { faShieldAlt } from '@fortawesome/pro-light-svg-icons';
import SSO from './SSO';
import MFA from './MFA';
import { useFeatureFlag, FeatureFlag } from 'src/helpers/featureFlag';

export const CompanySecurity: FC = () => {
  const isAuthMfaFeature = useFeatureFlag(FeatureFlag.Auth_2FA);
  const isAuthSsoFeature = useFeatureFlag(FeatureFlag.Auth_SSO);
  const { data: me } = useMe();
  const email = me?.email;
  const isAdmin = !!me?.isAdmin;
  const { t } = useTranslation();

  return (
    <>
      <PageHeading title={t('Navigation.Settings.security')} icon={faShieldAlt} />
      <div className={styles.contentInner}>
        {isAuthMfaFeature && <MFA isAdmin={isAdmin} email={email} />}
        {isAuthSsoFeature && <SSO />}
      </div>
    </>
  );
};

export default CompanySecurity;
